module.exports = __webpack_public_path__ + "img/bg-login.d5a08c4a.png";